import { defineAction } from '~/prix'
import { z } from 'zod'
import protocolFetchAction from './protocolFetch.action.json' with { type: 'json' }
import { protocolObject } from '../protocolObject'

const protocolFetchDefinition = defineAction({
  ...protocolFetchAction,

  input: z.object({
    id: z.string().uuid(),
  }),
  output: protocolObject,
})

export default protocolFetchDefinition
